<template>
  <div dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="">
      <img class="wlogo" :src="pathLogo" />
    </div>
    <h3 style="font-size: 30px" class="text-center">{{ alldata.fullName }}</h3>
    <h3 style="font-size: 20px" class="text-center">{{ alldata.shortName }}</h3>

    <h3 class="text-center">كشف الحضور والإنصراف لموظف</h3>
    <h3 class="text-center">
      من<b style="margin-right: 10px">
        {{ convertToUi(options.DateFrom) }} <span>إلى </span>
        {{ convertToUi(options.DateTo) }}</b
      >
    </h3>
    <div style="direction: rtl" class="md-layout md-size-100 text-center">
      <div class="md-layout-item md-size-25 mt-25">
        <h4 class="text-left" style="margin-top: 60px; direction: rtl">
          <span class="header-style">الموظف</span> : {{ alldata.employeeName }}
        </h4>
      </div>

      <div class="md-layout-item md-size-25 mt-25">
        <h4
          class="text-left"
          style="margin-right: 20px; margin-top: 60px; direction: rtl"
        >
          <span class="header-style">الرقم الوظيفي</span> :
          {{ alldata.jobNumber }}
        </h4>
      </div>

      <div class="md-layout-item md-size-25 mt-25">
        <h4
          class="text-left"
          style="margin-right: 20px; margin-top: 60px; direction: rtl"
        >
          <span class="header-style">الادارة</span> :
          {{ alldata.departmentName }}
        </h4>
      </div>
      <div class="md-layout-item md-size-25 mt-25">
        <h4
          class="text-left"
          style="margin-right: 20px; margin-top: 60px; direction: rtl"
        >
          <span class="header-style">إجمالي عدد ساعات الحضور</span> :
          {{ alldata.totalAttendanceHours }}
        </h4>
      </div>
    </div>

    <md-table
      style="direction: rtl; margin-top: 60px"
      :value="items"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort"
      class="mytable paginated-table table-striped table-hover mt-25"
    >
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        :style="
          item.status == 'عطلة الأسبوع' || item.status == 'عطلة'
            ? { 'background-color': '#d3d3d3' }
            : { background: 'null' }
        "
      >
        <md-table-cell style="padding-right: 24px !important" md-label="اليوم"
          >{{ convert(item.date) }}
        </md-table-cell>

        <md-table-cell style="padding-right: 24px !important" md-label="اليوم"
          >{{ item.dayString }}
        </md-table-cell>

        <md-table-cell
          style="padding-right: 24px !important"
          md-label="وقت الحضور"
          >{{ item.timeIn }}
        </md-table-cell>

        <md-table-cell
          style="padding-right: 24px !important"
          md-label="وقت الإنصراف"
          >{{ item.timeOut }}
        </md-table-cell>

        <md-table-cell style="padding-right: 25px !important" md-label="الحالة"
          >{{ item.status }}
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div style="direction: rtl" class="md-layout md-size-100 text-center">
      <div class="md-layout-item md-size-20 mt-25">
        <h4 class="text-left" style="margin-top: 60px; direction: rtl">
          العطل : {{ alldata.totalHolidays }}
        </h4>
      </div>

      <div class="md-layout-item md-size-20 mt-25">
        <h4
          class="text-left"
          style="margin-top: 60px; margin-right: 20px; direction: rtl"
        >
          الإجازات : {{ alldata.totalVacations }}
        </h4>
      </div>

      <div class="md-layout-item md-size-20 mt-25">
        <h4
          class="text-left"
          style="margin-right: 20px; margin-top: 60px; direction: rtl"
        >
          الحضور : {{ alldata.totalPresents }}
        </h4>
      </div>

      <div class="md-layout-item md-size-25 mt-25">
        <h4
          class="text-left"
          style="margin-right: 20px; margin-top: 60px; direction: rtl"
        >
          الغياب : {{ alldata.totalAbcents }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  mounted() {},
  props: ["items", "alldata", "date", "pathLogo", "options"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getDate();

        // +
        // " , "
        // +
        // d.getHours() +
        // ":" +
        // d.getMinutes()
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-style {
  font-weight: bold;
  color: #000;
  font-size: 20px;
}
// .mytable .md-table-head {
//     background-color: #ddd !important ;

// }

// .md-table-head:last-child:not(:first-child) .md-table-head-label {
//     padding-right: 0px !important;
// }
// @import "../../assets/css/Timesheet";
</style>
